module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/19-cba48e8d91d40b21f6dde4e2be73e88b.png";